import React from 'react'

import GridDefault from './gridDefault'
import ListDefault from './listDefault'
import ListThemePreviews from './listThemePreviews'
import ListMarketingImages from './listMarketingImages'
import GridVideo from './gridVideo'

import { reportExperiment } from '../../../common/utils/analytics'
import {
  setLocalStorageItem,
  getLocalStorageItem
} from '../../../common/utils/localStorageHelpers'

import Experiment from '../experiment'
import Variant from '../experiment/variant'
import Preloader from './preloader'

const ProductList = ({
  items,
  currentSite,
  preferences,
  itemDecorator,
  muteVideo,
  location
}) => {
  const viewType = preferences.searchResultsViewType
  const videoMuted = preferences.searchVideoMuted

  const cache = {
    get: key => getLocalStorageItem(key),
    set: (key, value) => setLocalStorageItem(key, value)
  }

  if (viewType === 'grid') {
    if (currentSite === 'videohive') {
      return (
        <GridVideo
          items={items}
          viewType={viewType}
          videoMuted={videoMuted}
          muteVideo={muteVideo}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
        />
      )
    } else {
      return (
        <GridDefault
          items={items}
          viewType={viewType}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
          location={location}
        />
      )
    }
  } else {
    if (currentSite === 'themeforest') {
      return (
        <Experiment
          id="XHbr8E-VSVeHER8HvTH5gQ"
          onExperimentView={reportExperiment}
          location={location}
          cache={cache}
          defaultVariantId={0}
          forcedVariantId={
            location.query.variant && parseInt(location.query.variant)
          }
          preloader={<Preloader />}
        >
          <Variant variantId={0}>
            <ListDefault
              items={items}
              viewType={viewType}
              currentSite={currentSite}
              itemDecorator={itemDecorator}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          </Variant>
          <Variant variantId={1}>
            <ListDefault
              items={items}
              viewType={viewType}
              currentSite={currentSite}
              itemDecorator={itemDecorator}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          </Variant>
          <Variant variantId={2}>
            <div className="xp">
              <ListThemePreviews
                items={items}
                viewType={viewType}
                currentSite={currentSite}
                itemDecorator={itemDecorator}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            </div>
          </Variant>
          <Variant variantId={3}>
            <div className="xp">
              <ListThemePreviews
                items={items}
                viewType={viewType}
                currentSite={currentSite}
                itemDecorator={itemDecorator}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            </div>
          </Variant>
          <Variant variantId={4}>
            <div className="xp">
              <ListMarketingImages
                items={items}
                viewType={viewType}
                currentSite={currentSite}
                itemDecorator={itemDecorator}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            </div>
          </Variant>
          <Variant variantId={5}>
            <div className="xp">
              <ListMarketingImages
                items={items}
                viewType={viewType}
                currentSite={currentSite}
                itemDecorator={itemDecorator}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            </div>
          </Variant>
        </Experiment>
      )
    } else {
      return (
        <ListDefault
          items={items}
          viewType={viewType}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
          videoMuted={videoMuted}
          muteVideo={muteVideo}
        />
      )
    }
  }
}

export default ProductList



// WEBPACK FOOTER //
// ./client/components/productList/index.js